export default __webpack_public_path__ + "static/media/welt.18611d4d.png";